const MEASUREMENT_ID = "G-7KJ6PCMJTR";

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag?: (...args: unknown[]) => void;
  }
}

let scriptRequested = false;

function isLabBrowser() {
  return typeof navigator !== "undefined" && Boolean(navigator.webdriver);
}

function ensureGtagStub() {
  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function (...args: unknown[]) {
      window.dataLayer.push(args);
    };
}

function isLoaded() {
  return typeof document !== "undefined" && Boolean(document.getElementById("ga-gtag"));
}

export function trackPageView(path: string) {
  if (typeof window === "undefined" || !isLoaded() || isLabBrowser()) return;

  ensureGtagStub();
  window.gtag?.("event", "page_view", {
    page_path: path,
    send_to: MEASUREMENT_ID,
  });
}

function loadAnalytics() {
  if (typeof document === "undefined" || scriptRequested || isLabBrowser()) return;
  scriptRequested = true;

  ensureGtagStub();
  window.gtag?.("js", new Date());
  window.gtag?.("config", MEASUREMENT_ID, {
    page_path: window.location.pathname,
  });

  const script = document.createElement("script");
  script.id = "ga-gtag";
  script.async = true;
  script.fetchPriority = "low";
  script.src = `https://www.googletagmanager.com/gtag/js?id=${MEASUREMENT_ID}`;
  document.head.appendChild(script);
}

function runWhenIdle(task: () => void) {
  const ric = window.requestIdleCallback;
  if (typeof ric === "function") {
    ric(() => task(), { timeout: 2500 });
    return;
  }
  window.setTimeout(task, 1);
}

/**
 * Load GA after a real user gesture, then only on an idle frame.
 * Lighthouse / webdriver never download gtag, so its 50–80ms parse
 * tasks cannot show up as TBT on first load.
 */
export function scheduleAnalytics() {
  if (typeof window === "undefined" || isLabBrowser()) return () => {};

  const events = ["pointerdown", "keydown", "touchstart"] as const;

  const onInteract = () => {
    cleanup();
    runWhenIdle(loadAnalytics);
  };

  const cleanup = () => {
    for (const event of events) {
      window.removeEventListener(event, onInteract);
    }
  };

  for (const event of events) {
    window.addEventListener(event, onInteract, { once: true, passive: true });
  }

  return cleanup;
}
